import { AxiosInstance, AxiosError } from 'axios';
import {
  WhereaboutsCheckApiFactory,
  WhereaboutsCheckResultResponse,
} from '@/repository/manager/whereaboutsCheck/openapi/generated';
import { ErrorPresenter } from '@/repository/errorPresenter/types';
import { ResultCache } from '@/repository/manager/whereaboutsCheck/resultCache';

export default function (axios: AxiosInstance, cache: ResultCache) {
  const api = WhereaboutsCheckApiFactory(undefined, undefined, axios);
  return (errorPresenter: ErrorPresenter): WhereaboutsCheckResultRepository => ({
    get: async (version) => {
      // 既に同じバージョンがローカルストレージにあればそのまま利用する
      const result = cache.load(version);
      if (result) {
        return result;
      }
      try {
        // リモートから取得する
        const { data } = await api.getWhereaboutsCheckResult();
        const result = adapt(data);
        // ローカルストレージに保存する
        cache.save(result, version);
        return result;
      } catch (e: unknown) {
         const err = e as AxiosError;
        errorPresenter({
          status: err.response?.status,
          error: err,
          requestUrl: err.config?.url,
        });
        throw err;
      }
    },
    clearCache: () => {
      cache.clear();
    },
  });
}

const adapt = (data: WhereaboutsCheckResultResponse): WhereaboutsCheckResult => {
  return {
    checkNGChildren: data.checkResultNGChildren.map((child) => ({
      id: child.childId,
      name: child.childName,
    })),
  };
};
